import { Controller } from "@hotwired/stimulus"

// Apre o chiude una finestra (dialog_controller) per id: data-action="dialog-opener#open" data-dialog-opener-id-param="…".
export default class extends Controller {
  open(event) {
    window.dispatchEvent(new CustomEvent("dialog:open", { detail: { id: event.params.id } }))
  }

  close(event) {
    window.dispatchEvent(new CustomEvent("dialog:close", { detail: { id: event.params.id } }))
  }
}
